export class VwSchoolTerm{
    public ID: Number;
      public TermName: String;
      public Name : String;
      public TermYear : String;
      public StartDate: Date;
      public EndDate :Date;
      public NumberOfDays: Number;
      public CreatedBy : String;
      public DateCreated : Date;
      public LastModifiedBy : String;
      public DateLastModified : Date;
  }